import { useEffect } from 'react';

import { FULFILLED } from '../constants/actionStatusConstants';

export default (statuses, action) => {
  useEffect(() => {
    if (statuses.includes(FULFILLED)) action();
  }, [statuses, action]);
};
